// Feito pelo Thiago Munich

import React, { useContext, useState } from 'react';

import { ContextSolicitacoes } from '../../../services/solicitacoes';

import './pdfStyle.css';
import Swal from 'sweetalert2';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import { AccessDevice } from '../../../Utils/documentUpload';
import { GrDocumentPdf, GrDocumentVideo } from 'react-icons/gr';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import AddBoxOutlinedIcon from '@material-ui/icons/AddBoxOutlined';
import Typography from '@material-ui/core/Typography';
import MessagePopup from '../../MessagePopup';
import { ButtonPrimary } from '../../StyledComponent';
import { ContextSindico } from '../../../services/sindico';

const useStyles = makeStyles({
  boxOfImages: {
    width: 56,
    height: 56,
    display: 'flex',
    marginLeft: 'auto',
    alignItems: 'center',
    background: '#848484',
    borderTopLeftRadius: 4,
    justifyContent: 'center',
    borderBottomLeftRadius: 4,
  },
  trashCircle: {
    width: 20,
    height: 20,
    zIndex: 99,
    padding: 4,
    display: 'flex',
    right: -14,
    borderRadius: '50%',
    position: 'absolute',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#BA122B',
  },
  trashCircleWhite: {
    width: 20,
    height: 20,
    display: 'flex',
    right: -10,
    borderRadius: '50%',
    position: 'absolute',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#FFF',
  },
  imagesDiv: {
    display: 'flex',
    marginRight: 24,
    alignItems: 'center',
    position: 'relative',
    flexDirection: 'row',
    border: '1px solid #d4d4d4',
    padding: '4px 8px',
    borderRadius: 4,
  },
});

const GENERAL_MAX_FILES = 3;
const CESSAO_DIREITOS_MAX_FILES = 3;

export default function AttachDocuments({
  documents,
  setDocuments,
  reparos,
  readOnly,
  tema,
  isSindico,
  tipoAtendimentoSolicitacao,
}) {
  const isTypeCessaoDireitos =
    tipoAtendimentoSolicitacao === 'Cessão de Direitos';

  const fileQuantityAllowed = isTypeCessaoDireitos
    ? CESSAO_DIREITOS_MAX_FILES
    : GENERAL_MAX_FILES;

  const classes = useStyles();

  const { removedDocuments, setRemovedDocuments } = useContext(
    isSindico ? ContextSindico : ContextSolicitacoes
  );

  const [showConfirmDeletePopup, setShowConfirmDeletePopup] = useState(false);

  const [selectedDocumentToRemove, setSelectedDocumentToRemove] = useState({});

  const showConfirmRemoveDocumentPopup = (image) => {
    setShowConfirmDeletePopup(true);
    setSelectedDocumentToRemove(image);
  };

  const handleClickConfirmRemoveDocument = () => {
    removeDocumentFromArray(selectedDocumentToRemove);
    setShowConfirmDeletePopup(false);
  };

  const removeDocumentFromArray = (image) => {
    if (documents?.documents === undefined) {
      setDocuments(documents?.filter((item) => item !== image));
    } else {
      // array auxiliar para caso de remoção de arquivos com chamada a API
      if (image.url !== undefined) {
        // Garante que não serão inseridos arquivos repetidos no array de remoção
        setRemovedDocuments([
          ...removedDocuments.filter((item) => item.idAws !== image.idAws),
          image,
        ]);
      }

      let newReparos = [];

      reparos.map((reparo) => {
        if (reparo.idSelecaoReparo === documents.idSelecaoReparo) {
          newReparos.push({
            ...reparo,
            documents: reparo.documents.filter((item) => item !== image),
          });
        } else {
          newReparos.push(reparo);
        }
      });

      setDocuments(newReparos);
    }
  };

  const checkIfDocumentsIsArrayOrObject = () => {
    if (documents?.idSelecaoReparo === undefined) {
      return documents;
    } else {
      return documents?.documents;
    }
  };

  const gridSize = () => {
    if (documents?.documents === undefined) {
      return documents?.length > 0 ? 5 : 12;
    } else {
      return 12;
    }
  };

  const accessDeviceButtonId = () => {
    if (documents?.documents === undefined) {
      return 'selectFile';
    } else {
      return documents?.documents?.idSelecaoReparo;
    }
  };

  const disableAccessDeviceButton = () => {
    const MAX_FILES = isTypeCessaoDireitos
      ? CESSAO_DIREITOS_MAX_FILES
      : GENERAL_MAX_FILES;

    if (readOnly) {
      return true;
    }

    if (documents?.documents === undefined) {
      return documents?.length === MAX_FILES;
    }

    return documents?.documents?.length === MAX_FILES;
  };

  const renderDocument = (document) => {
    const imageRender = () => {
      if (document.url !== undefined) {
        return document.url;
      } else {
        return window.URL.createObjectURL(document);
      }
    };

    const videoRender = () => {
      if (document.url !== undefined) {
        window.open(document.url);
      } else {
        return document;
      }
    };

    if (typeof document === 'object') {
      if (
        document?.nomeArquivo?.includes('.jpeg') ||
        document?.nomeArquivo?.includes('.jpg') ||
        document?.nomeArquivo?.includes('.png') ||
        document?.type?.includes('image')
      ) {
        return (
          <img
            width='48'
            height='50'
            alt={document?.lastModified}
            style={{ borderRadius: 8 }}
            onClick={() => {
              (async function showModal() {
                await Swal.fire({
                  confirmButtonColor: '#29333C',
                  confirmButtonText: '        FECHAR        ',
                  html:
                    "<img width='312' height='451' alt='Imagem' src='" +
                    imageRender() +
                    "' />",
                });
              })();
            }}
            src={imageRender()}
          />
        );
      } else if (document?.nomeArquivo?.includes('.pdf')) {
        return (
          <GrDocumentPdf
            onClick={() => window.open(document.url)}
            style={{ width: 48, height: 50, borderRadius: 8 }}
          />
        );
      } else if (document?.nomeArquivo?.includes('.mp4')) {
        return (
          <GrDocumentVideo
            onClick={() => window.open(document.url)}
            style={{ width: 48, height: 50, borderRadius: 8 }}
          />
        );
      } else {
        return (
          <img
            width='48'
            height='50'
            alt={document?.name}
            style={{ borderRadius: 8 }}
            onClick={() => {
              (async function showModal() {
                await Swal.fire({
                  confirmButtonColor: '#29333C',
                  confirmButtonText: '        FECHAR        ',
                  html:
                    "<img width='312' height='451' alt='Imagem' src='" +
                    imageRender() +
                    "' />",
                });
              })();
            }}
            src={imageRender()}
          />
        );
      }
    } else if (typeof document === 'string') {
      if (document?.includes('application/pdf')) {
        return (
          <GrDocumentPdf
            style={{ width: 48, height: 50, borderRadius: 8 }}
            onClick={() => {
              (async function showModal() {
                await Swal.fire({
                  allowOutsideClick: false,
                  title:
                    "<h5 style='color: #A93335; margin-top: 8px; margin-bottom: 0px'>Pré-visualização indisponível</h5>",
                  confirmButtonColor: '#29333C',
                  confirmButtonText: '        OK, ENTENDI        ',
                  html: '<strong>No momento não é possível visualizar documentos do tipo PDF.</strong>',
                });
              })();
            }}
          />
        );
      } else if (document?.includes('video')) {
        return (
          <GrDocumentVideo
            style={{ width: 48, height: 50, borderRadius: 8, marginLeft: 8 }}
            onClick={() => {
              (async function showModal() {
                await Swal.fire({
                  confirmButtonColor: '#29333C',
                  confirmButtonText: '        FECHAR        ',
                  html:
                    "<video controls width='450' height='245'><source type='video/mp4' src='" +
                    videoRender() +
                    "' ></source><video>",
                });
              })();
            }}
          />
        );
      }
    }
  };

  return (
    <>
      <Grid
        container
        justify='center'
        direction='column'
        style={{ marginTop: 16 }}
      >
        {!disableAccessDeviceButton() && (
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            xl={12}
            justify='center'
            alignItems='center'
            alignContent='center'
          >
            {
              <AccessDevice
                tema={tema}
                reparos={reparos}
                documents={documents}
                id={accessDeviceButtonId()}
                setDocuments={setDocuments}
                buttonText='Anexar arquivo'
                buttonIcon={<AddBoxOutlinedIcon style={{ marginLeft: 12 }} />}
                fileQuantityAllowed={fileQuantityAllowed}
              />
            }
          </Grid>
        )}
        {checkIfDocumentsIsArrayOrObject()?.length > 0 && (
          <Grid
            item
            xs={12}
            sm={12}
            md={gridSize()}
            lg={gridSize()}
            xl={gridSize()}
            container
            // alignItems="center"
            style={{
              // maxHeight: 60,
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <Typography
              variant='caption'
              color='textPrimary'
              style={{
                padding: '4px 0 8px 0',
                display: 'block',
                color: '#4d4d4d',
                fontWeight: 700,
                fontSize: 16,
              }}
            >
              Anexos:
            </Typography>
            <div style={{ display: 'flex' }}>
              {checkIfDocumentsIsArrayOrObject()?.map((document, index) => {
                return (
                  <div key={index} className={classes.imagesDiv}>
                    {renderDocument(document)}
                    {!readOnly && (
                      <>
                        <div className={classes.trashCircleWhite} />
                        <div
                          className={classes.trashCircle}
                          onClick={() =>
                            showConfirmRemoveDocumentPopup(document)
                          }
                        >
                          <DeleteForeverIcon
                            style={{ color: '#FFF', marginLeft: '0px' }}
                            fontSize='small'
                          />
                        </div>
                      </>
                    )}
                  </div>
                );
              })}
            </div>
            {showConfirmDeletePopup && (
              <MessagePopup
                isError
                title={'Remover anexo'}
                message={
                  'Tem certeza que deseja remover esse anexo? Essa ação não pode ser desfeita.'
                }
              >
                <ButtonPrimary
                  light
                  fullWidth
                  tema={tema}
                  onClick={() => setShowConfirmDeletePopup(false)}
                >
                  Cancelar
                </ButtonPrimary>
                <ButtonPrimary
                  fullWidth
                  tema={{ primaryColor: '#B91C1C' }}
                  onClick={handleClickConfirmRemoveDocument}
                >
                  Remover
                </ButtonPrimary>
              </MessagePopup>
            )}
          </Grid>
        )}
      </Grid>
    </>
  );
}
